/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminCreateDto } from '../../models/admin-create-dto';
import { AdminDto } from '../../models/admin-dto';

export interface AdminControllerCreate$Params {
      body: AdminCreateDto
}

export function adminControllerCreate(http: HttpClient, rootUrl: string, params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDto>;
    })
  );
}

adminControllerCreate.PATH = '/api/admin';
